import axios from 'axios';

/**
 * Creates a configured Axios HTTP client instance with a base URL and credentials.
 *
 * - Sets the provided `baseURL` for all requests (defaults to an empty string).
 * - Enables sending credentials (cookies, authorization headers) with requests.
 * - Adds a response interceptor:
 *    - Returns `response.data` on success.
 *    - On error, rejects with the error response data, unless the error is a cancellation.
 *
 * @param config - Configuration object.
 * @param {string} - The base URL for all HTTP requests.
 * @returns A configured Axios instance.
 */
export const createhttp = ({ baseURL = '' }) => {
  const axiosInstance = axios.create({
    baseURL,
    withCredentials: true,
  });

  axiosInstance.interceptors.response.use(
    response => response.data,
    error => {
      if (axios.isCancel(error)) {
        return Promise.reject(error);
      }
      return Promise.reject(error.response.data);
    }
  );

  return axiosInstance;
};
